import AppletProfile from "./applet_profile.entity";

export default class AppletSubgroupType {
  public id = '';

  public title = '';

  public validType = '';

  public profiles: AppletProfile[];

  constructor(data: any = {}) {
    this.id = data.id || '';
    this.title = data.title || '';
    this.validType = data.valid_type || '';
    this.profiles = (data.profiles && data.profiles.length)
      ? data.profiles.map((profile: any) => new AppletProfile(profile))
      : [];
  }
}
